/* eslint no-console:0 */

import React from 'react';
import { mountReactApp } from '../helpers/mountReactApp';
import ChartPage from '../components/ChartPage/index';

var el = document.getElementById('pack-chart-container');

mountReactApp(
  el.appendChild(document.createElement('div')),
  <ChartPage/>,
);
